import styled from "styled-components";

export const DescriptionWrapper = styled.div`
  width: ${(props): string => props.theme.spacing(30)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
